var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "event-list" } },
    [
      _c("div", { staticClass: "row mb-3 mx-1 mx-md-0" }, [
        _c("div", { staticClass: "col-12 col-sm d-flex align-items-center" }, [
          _c("h4", {
            staticClass: "mb-md-0 font-weight-normal",
            domProps: {
              innerHTML: _vm._s(
                _vm.$tc(
                  "ui.views.social_events.index.event_list.results_html",
                  _vm.events.length,
                  { count: _vm.events.length }
                )
              ),
            },
          }),
        ]),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-sm-auto d-flex flex-column align-items-sm-end",
          },
          [
            _c("ci-button", {
              staticClass: "w-100",
              attrs: {
                to: { name: _vm.$routes.WEBCASTS_INDEX },
                variant: "outline-primary",
                size: "sm",
                label: _vm.$t(
                  "ui.views.social_events.index.event_list.past_events"
                ),
              },
            }),
          ],
          1
        ),
      ]),
      _vm._l(_vm.events, function (event) {
        return _c(
          "div",
          { key: event.id, staticClass: "col-12 list_content" },
          [
            _c("ci-social-event-tile", {
              attrs: { "data-event": event, context: "event_page" },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }